<!--
    Summary:
      亲子鉴定（产前或产后）
        hkml.exhibition.web - paternity-test
    ChangeLog:
        wangn on 2020/11/16 added
-->
<template>
  <div class="v-paternity-test" title="paternity-test">
    <sub-banner>
      <img src="../../../assets/images/projects/paternity-test/p1.jpg"/>
      <div slot="title" class="p-t-title">
        {{$t('PaternityTest.p1_title')}}
        <br />
        {{$t('PaternityTest.p1_title_2')}}
      </div>
      <a href="/" slot="action">{{$t('PaternityTest.p1_action')}}</a>
    </sub-banner>

    <p2-paternity-test2></p2-paternity-test2>
    <p3-paternity-test3></p3-paternity-test3>
    <p4-paternity-test4></p4-paternity-test4>
    <p6-advantages></p6-advantages>

    <p7-procedures></p7-procedures>
    <p8-attention></p8-attention>
  </div>
</template>

<script>
  import SubBanner from "@/components/sub-banner";
  import P2PaternityTest2 from "./p2-paternity-test2";
  import P3PaternityTest3 from "./p3-paternity-test3";
  import P4PaternityTest4 from "./p4-paternity-test4";
  import P6Advantages from "./p6-advantages";
  import P7Procedures from "../y-dna-test/p7-procedures";
  import P8Attention from "../y-dna-test/p8-attention";

  export default {
    name: "paternity-test",
    components: {SubBanner, P8Attention, P7Procedures, P6Advantages, P4PaternityTest4, P3PaternityTest3, P2PaternityTest2}
  }
</script>
<style lang="scss">
  .en .v-paternity-test{
    .p-t-title{
      line-height: 2.5vw !important;
      text-align: center;
    }
    p {
      font-size: 1.20vw;
    }
  }
</style>
<style lang="scss">
  .v-paternity-test {
    p {
      font-size: 1.52vw;
      line-height: 3.13vw;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0;
      color: #000000;
    }
  }
</style>




// WEBPACK FOOTER //
// src/view/projects/paternity-test/paternity-test.vue